import styles from "./ImageCarouselWithTags.module.scss";
import ImageSection from "../ImageSection";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import Image from "@Components/Image";
import PropertyTags from "../PropertyTags";
import wrapperHOC from "@Utils/wrapperHOC";
import getImagePath from "@Utils/getImagePath";
import useIsMiniProgram from "hooks/useIsMiniProgram";
import YellowStar from "@Icons/YellowStar";
import VectorSearchBelowRating from "@Icons/VectorSearchBelowRating";
import UALBannerStyles from "../../searchListItemV2.module.scss";

type ImageCarouselWithTagsProps = {
  images: any[];
  index: number;
  wrapRef?: any;
  inventoryData: any;
  dataTestId?: string;
  videos?: any[];
  className?: string;
  showOnlyFeaturedImage?: boolean;
  isDesktop: boolean;
  isGridView?: boolean;
  isAgentView?: boolean;
  isSalesOfferAvailable?: boolean;
  showRatings?: boolean;
  reviews_rating?: string;
  reviews_count?: string;
  showUalSalesBanner?: boolean;
};

const ImageCarouselWithTags = ({
  images,
  index,
  wrapRef = null,
  inventoryData,
  dataTestId,
  videos = [],
  className,
  showOnlyFeaturedImage,
  isDesktop,
  isGridView,
  isAgentView = false,
  isSalesOfferAvailable = false,
  showRatings,
  reviews_rating,
  reviews_count,
  showUalSalesBanner = false,
}: ImageCarouselWithTagsProps) => {
  const imgAltPrefix = `${inventoryData?.name} - ${inventoryData?.region?.combined_name}`;
  const isMiniProgram = useIsMiniProgram();

  return (
    <div
      ref={wrapRef}
      className={formatClassNames(
        styles.carouselContainer,
        isDesktop && styles.desktop,
        isAgentView && styles.agentView,
        isGridView && styles.gridView,
      )}
      data-testid="searchPage-inventoryCard-image"
    >
      {showOnlyFeaturedImage ? (
        <div className={className}>
          <Image
            src={getImagePath(images?.[0]?.base_path, "gallery-image-small")}
            width="100%"
            height="100%"
            alt={`${imgAltPrefix} - ${images?.[0]?.caption}`}
          />
        </div>
      ) : (
        <ImageSection
          index={index}
          images={images?.slice(0, 5).map((it) => it?.base_path)}
          videos={videos}
          dataTestId={dataTestId}
          isDesktop={isDesktop}
          className={className}
          altData={`${imgAltPrefix} - ${images?.[0]?.caption}`}
          maxDots={5}
          isGridView={isGridView}
          isMiniProgram={isMiniProgram}
        />
      )}
      {/* <div className={styles.carouselIconsContainerDesktop}>
        {(virtual_views?.length || meta?.total_virtual_views_count) > 0 && (
          <TranslucentIconTag dataTestId="3D">3D</TranslucentIconTag>
        )}
        {(videos?.length || meta?.total_videos_count) > 0 && (
          <TranslucentIconTag dataTestId="Video">
            <VideoIcon />
          </TranslucentIconTag>
        )}
      </div> */}
      <PropertyTags
        inventory={inventoryData}
        hideCashbackValue={isDesktop}
        dataTestId="searchPage-property-soldOut-tag"
        className={isGridView && isSalesOfferAvailable && styles.gridViewSoldOutTag}
        isSalesOfferAvailable={isSalesOfferAvailable}
      />
      {showRatings && (isGridView || !isDesktop) && (
        <div className={styles.ratingWrapper}>
          <div className={styles.ratingBackground}>
            <VectorSearchBelowRating />
          </div>
          <div className={styles.ratingOverlay}>
            <YellowStar />
            <span className={styles.ratingValue}>{reviews_rating}</span>
            <span className={styles.ratingCount}>({reviews_count})</span>
          </div>
        </div>
      )}
      {showUalSalesBanner && !isGridView && (
        <div
          className={formatClassNames(
            UALBannerStyles.ualSalesBannerSmall,
            !isGridView && UALBannerStyles.listView,
          )}
        >
          <Image
            src="http://static-assets.amberstudent.com/images/amber-fest/en/usal-sales-banner-small.png"
            alt="UAL Sales Banner"
            width="100%"
            height="auto"
          />
        </div>
      )}
    </div>
  );
};

export default wrapperHOC(ImageCarouselWithTags, {
  componentName: "ImageCarouselWithTags-SearchListItemDesktop-SearchPage",
  showForChina: true,
});
